import { z } from 'zod'
import { Normalization } from '~/utils/normalization'

export const codePointText = (maxLength: number): z.ZodString =>
  z
    .string()
    .refine(
      (value) => Normalization.codePointLength(value) <= maxLength,
      `The text must not be greater than ${maxLength} characters.`
    )
